import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';
import { newCalculationStarted } from './historySlice';

interface StepState {
  currentIdx: number;
}

const initialState: StepState = {
  currentIdx: 0
};

const resetStep = (state: StepState) => {
  state.currentIdx = 0;
};

export const stepSlice = createSlice({
  name: 'step',
  initialState,
  reducers: {
    next: state => {
      state.currentIdx += 1;
    },
    previous: state => {
      state.currentIdx -= 1;
    },
    stepReset: resetStep
  },
  extraReducers: builder => {
    builder.addCase(newCalculationStarted, resetStep);
  }
});

export const { next, previous, stepReset } = stepSlice.actions;

export const stepIdxSelector = (state: RootState) => state.step.currentIdx;

export default stepSlice.reducer;
